module.exports = __webpack_public_path__ + "public/img/箭头_下一页.0e425ba7.svg";